module.exports = __webpack_public_path__ + "static/img/4004.7429aab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4004.png
// module id = 711
// module chunks = 0 1 12